import React, { createContext, useContext, useReducer } from 'react';
import api from '../utils/api';
import {
  ERROR,
} from '../utils/constants';
import { ICardData } from '../utils/interfaces';
import { AlertMessageContext } from './AlertMessageContext';
import { LoadingContext } from './LoadingContext';

/* --------------------------------------------------------------- */

interface IInitialState {
  cards: Array<ICardData>;
  card: ICardData | null;
  amountOfPrevCards: number;
}

interface IAction {
  type: string,
  payload: any
}

interface IProps {
  children: any
}

interface IHandlers {
  [key: string]: Function,
}

/* --------------------------------------------------------------- */

const initialState: IInitialState = {
  cards: [],
  card: null,
  amountOfPrevCards: 0
};

const handlers: IHandlers = {
  SET_CARD: (state: object, action: IAction) => {
    return {
      ...state,
      card: action.payload
    };
  },
  SET_CARDS: (state: object, action: IAction) => {
    return {
      ...state,
      cards: action.payload
    };
  },
  SET_AMOUNT_OF_PREV_CARDS: (state: object, action: IAction) => {
    return {
      ...state,
      amountOfPrevCards: action.payload
    };
  }
};

const reducer = (state: object, action: IAction) =>
  handlers[action.type] ? handlers[action.type](state, action) : state;

//  Context
const CardsContext = createContext({
  ...initialState,
  getAllCardsAct: () => Promise.resolve(),
  getCardByIdAct: (id: number) => Promise.resolve(),
  clearOrderAct: () => Promise.resolve()
});

//  Provider
function CardsProvider({ children }: IProps) {
  const { openLoading, closeLoading } = useContext(LoadingContext);
  const { openAlert } = useContext(AlertMessageContext);

  const [state, dispatch] = useReducer(reducer, initialState);

  const getAllCardsAct = () => {
    // openLoading()
    api.get('/admin/getAllCards')
      .then(response => {
        dispatch({
          type: 'SET_AMOUNT_OF_PREV_CARDS',
          payload: state.cards.length
        });
        dispatch({
          type: 'SET_CARDS',
          payload: response.data
        })
        // closeLoading()
      })
      .catch(error => {
        openAlert({
          severity: ERROR,
          message: error?.response?.data || ERROR
        })
        // closeLoading()
      })
  };

  const getCardByIdAct = (id: number) => {
    openLoading()
    const card = state.cards.find((cardItem: ICardData) => cardItem.id === id)
    dispatch({
      type: 'SET_CARD',
      payload: card || null
    })
    closeLoading()
  }

  const clearOrderAct = () => {
    dispatch({
      type: 'SET_CARD',
      payload: null
    })
  }

  return (
    <CardsContext.Provider
      value={{
        ...state,
        getAllCardsAct,
        getCardByIdAct,
        clearOrderAct
      }}
    >
      {children}
    </CardsContext.Provider>
  );
}

export { CardsContext, CardsProvider };